import { Icon, IconButton } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { IFilteringViewModel, ITableData } from "../../_common/interface/table";
import { CommonTable } from "../../_components/table/common.table";
import { PaperTableHeader } from "../../_components/table/header.table";
import { SearchTableHeader } from "../../_components/table/search.table";
import { TABLE_FILTER } from "../../_const/tableFilter.const";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formTemplateService } from "../../_services/formTemplate.service";
import { FormTemplateManageDrawer } from "./formTemplate-manageDrawer";
import { FormTemplateSectionList } from "./formTemplateSection.tsx/formTemplateSection-list";
import { FormTemplateSectionManage } from "./formTemplateSection.tsx/formTemplateSection-manage";


export function FormTemplateIndex() {

    const [data, setData] = useState<ITableData<any>>({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(true);
    const [filter, setFilter] = useState<IFilteringViewModel>({ ...TABLE_FILTER });

    let navigate = useNavigate();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate(`Manage/${row.original.id}`) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'userTypeName',
                header: 'User type',
                accessorFn: (rowData: any) => rowData.userTypeName ?? (rowData.formTemplateId ? "-" : "All"),
            },
            {
                accessorKey: 'formStatusName',
                header: 'Form Status Name',
            },
            {
                accessorKey: 'sectionOrder',
                header: 'Section Order',
                accessorFn: (rowData: any) => rowData.sectionOrder ?? "-"
            },
            {
                accessorKey: 'createdBy',
                header: 'Created By',
            },
            {
                accessorKey: 'modifiedBy',
                header: 'Modified By',
            },
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {
        
        setLoading(true);

        return formTemplateService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>

            <PaperTableHeader title="Form Templates" buttons={[
                { icon: "add", label: "Create", onClick: () => { navigate("Create") } }
            ]} />

            <SearchTableHeader inputs={[
                { label: "Name", name: "name", onChange: setFilter, value: filter.name },
            ]} />

            <CommonTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

            <Routes>

                <Route path="/Create" element={<FormTemplateManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} />

                <Route path="/Manage/:formTemplateId/" element={<FormTemplateManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} >
                    <Route path="CreateSection" element={<FormTemplateSectionManage emitOnSave={() => { }} />} />
                    <Route path="EditSection/:formTemplateSectionId" element={<FormTemplateSectionManage emitOnSave={() => { }} />} />
                    <Route path="" element={<FormTemplateSectionList />} />
                </Route>

            </Routes>
        </>
    );

}
